import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {ActionHandler} from "../../../../infrastructure/handlers/action-handler";
import {SearchBarClickEvent} from "../../../../core/models/events/search-bar-click-event";

export class NewSearchWidgetSearchClickEventHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSearchClickEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  async action(params) {
    if(params.source){
      const clickEvent: SearchBarClickEvent = new SearchBarClickEvent(params.source);

      this.analyticsService.createEvent(clickEvent);
    }
  }
}
